import { appStore } from '../../app/AppStore';
import { bindDisplaySettingsScopeToReduxAndSetInitialValues } from '../../app/content/DisplaySettingsReduxBindings';
import { bindDisplaySettingsScopeToUrlAndSetInitialValues } from '../../app/content/DisplaySettingsUrlBindings';
import { IMainScope } from '../../app/IMainScope';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { isMetricSpace } from '../../app/state/SpaceInfo';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { TelemetryService } from '../services/TelemetryService';

export class MainCtrl {

  public static $inject = [
    '$scope',
    '$location',
    'AngularContextFactory',
    'TelemetryService',
    'DataSources'
  ];

  constructor($scope: IMainScope,
              $location: ng.ILocationService,
              angularContextFactory: AngularContextFactory,
              telemetryService: TelemetryService,
              datasourcesResource: DataSources) {
    const angularContext = angularContextFactory.create($scope);
    $scope.pageHeaderProps = {
      angularContext,
      telemetryService,
      datasourcesResource
    };
    $scope.leftNavProps = {
      telemetryService
    };

    $scope.getConstrainedClass = () => {
      // The Metrics Detail page is fully responsive so let's make sure we don't
      // add a mid-width constraint to it so that content can reflow properly.
      if (isMetricSpace(selectSpaceInfo(appStore.getState()))) return '';
      return 'tb-main-constrained';
    };

    const queryString = getQueryStringServiceFromAngular($location);
    bindDisplaySettingsScopeToReduxAndSetInitialValues($scope, appStore);
    bindDisplaySettingsScopeToUrlAndSetInitialValues($scope, appStore, queryString);
  }
}

Module.instance().controller('MainCtrl', MainCtrl);
